import { startTimeOfDayFromRRuleString } from "./utils/wall-clock-time.js";
import { MINUTES_PER_DAY } from "./timeline-range.js";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
//#region src/components/RRule/day-timeline-range-source.ts
dayjs.extend(utc);
dayjs.extend(timezone);
var DEFAULT_FROM_MIN = 600;
function wrapClock(min) {
	return (min % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}
function clockMinutes(iso, tz) {
	const d = tz ? dayjs(iso).tz(tz) : dayjs(iso);
	return d.hour() * 60 + d.minute();
}
function clockRangeFromRRule(rrule, durationMin) {
	const duration = Math.max(1, durationMin);
	const start = startTimeOfDayFromRRuleString(rrule);
	const fromMin = start ? start.hour * 60 + start.minute : DEFAULT_FROM_MIN;
	return {
		durationMin: duration,
		fromMin,
		toMin: wrapClock(fromMin + duration)
	};
}
function clockRangeFromInstance(window, timezone) {
	const fromMin = clockMinutes(window.startsAt, timezone);
	const durationMin = Math.max(1, dayjs(window.endsAt).diff(dayjs(window.startsAt), "minute"));
	return {
		durationMin,
		fromMin,
		toMin: wrapClock(fromMin + durationMin)
	};
}
//#endregion
export { clockRangeFromInstance, clockRangeFromRRule };

//# sourceMappingURL=day-timeline-range-source.js.map